<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-one-it-has-begun">
<h1 style="margin-top:250px;font-family:Arial;">Part One<br/> It Has Begun</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?2aaf4f7a